import * as React from 'react'
import {Card, CardImg, Row, Col,Collapse,CardBody} from "reactstrap";
import {connect} from "react-redux";
import {WithTranslation, withTranslation} from "react-i18next";
import {ConfiguratorProduct, ConfiguratorProductSpinsets, DocumentsInner, Product, ConfiguratorProductShowrooms} from "App/services/api";
import {selectedLang} from "App/helper";
import ImageGallery from "react-image-gallery";
import {Language} from "App/constants";

export interface ComponentProps {
    product: Product
    configuration: ConfiguratorProduct
    className: string
}

interface DispatchToProps {
}

function initialState (): ComponentState {
    return {
        isVisible: false
    }
}

interface ComponentState {
    isVisible: boolean
}

class _Component extends React.PureComponent<DispatchToProps & ComponentProps & WithTranslation,ComponentState> {

    toggleVisibility() {
        this.setState((state, props) => ({
            isVisible: !state.isVisible
        }));
    }

    constructor(props: ComponentProps & DispatchToProps & WithTranslation, context: any) {
        super(props, context);
        this.state = initialState();
    }

    render() {
        const { t, i18n, configuration, product, className } = this.props;
        const language: Language = selectedLang(i18n);
        const additionalImages = configuration.additionalimages.length?configuration.additionalimages.map((image: string, index: number) => {
            return {
                original: image
            };
        }):null;

        const images = additionalImages&&product.iconurl?[
            {
                original: product.iconurl
            }
        ].concat(additionalImages):null;

        // Prepare configuration documents
        const documents: DocumentsInner[] | undefined =
            configuration.documents&&configuration.documents
            .filter(document => document.languages&&document.languages.indexOf(language)>=0);

        // Prepare showrooms
        const showRooms : ConfiguratorProductShowrooms[] | undefined =
            configuration.showrooms&&configuration.showrooms
            .filter(document => document.languages&&document.languages.indexOf(language)>=0);
        ;

        // Prepare specialdiscount documents
        const specialDiscountDocuments: DocumentsInner[] | undefined =
            configuration.specialdiscount&&configuration.specialdiscount.documents&&configuration.specialdiscount.documents
            .filter(document => document.languages&&document.languages.indexOf(language)>=0);

        return <React.Fragment>
        <Card className={"gallery " + className}>
            {
                images?
                    <ImageGallery items={images} lazyLoad={true} showThumbnails={false} useBrowserFullscreen={false}/>:
                    <CardImg src={product.iconurl} alt={configuration.nameml[language]} className="p-0"/>
            }
            {
                (configuration.spinsets&&configuration.spinsets.length)||
                (configuration.showrooms&&configuration.showrooms.length)||
                (documents&&documents.length)||
                (configuration.specialdiscount&&configuration.specialdiscount.documents&&configuration.specialdiscount.documents.length)?
                    <Row className="d-print-none no-gutters text-normal-details">
                        {
                            configuration.spinsets&&configuration.spinsets.map((item: ConfiguratorProductSpinsets, index: number) => {
                                return <a href={item.url} className="btn btn-light" target="_blank"><button className="configure w-100 text-uppercase text-left button-height-48 btn btn-secondary">                                    
                                    {
                                        item.type===ConfiguratorProductSpinsets.TypeEnum.SPINSETEXTERIOR?t('products.configuration.spinsetoutside'):
                                            item.type===ConfiguratorProductSpinsets.TypeEnum.SPINSETINTERIOR?t('products.configuration.spinsetinside'):
                                                t('products.configuration.spinset')
                                    }
                                </button></a>;
                            })
                        }
                        {
                            showRooms&&showRooms.map((item: ConfiguratorProductShowrooms, index: number) => {
                                return <a href={item.url} className="btn btn-light" title={item.name} target="_blank"><button className="configure w-100 text-uppercase text-left button-height-48 btn btn-secondary">{t('products.configuration.virtualtour')}</button></a>
                            })
                        }
                        {
                            (documents&&documents.length)||
                            (configuration.specialdiscount&&configuration.specialdiscount.documents&&configuration.specialdiscount.documents.length)?
                            <a className="btn btn-light"><button className="configure w-100 text-uppercase text-left button-height-48 btn btn-secondary" onClick={() => this.toggleVisibility()}>{ t('products.configuration.documents') }</button></a>:null
                        }
                    </Row>
                    : null
            }
        </Card>
        {
                (documents&&documents.length)||
                (configuration.specialdiscount&&configuration.specialdiscount.documents&&configuration.specialdiscount.documents.length)?
                    <Card className={"gallery " + className}>
                    <Collapse isOpen={this.state.isVisible}>
                        <CardBody className="px-5 pt-2 pb-3 bodyslice">
                        {
                            specialDiscountDocuments&&specialDiscountDocuments
                            .map((document: DocumentsInner, index: number) => {
                                return <Row title={document.description&&document.description[language]}><Col><a href={document.url} className="action text-normal-overview pl-1" target="_blank" >
                                <i className="far fa-file-download"></i> {document.description&&document.description[language]}</a></Col></Row>;
                            })
                        }
                        {
                            documents&&documents
                                .map((document: DocumentsInner, index: number) => {
                                    return <Row title={document.description&&document.description[language]}><Col><a href={document.url} className="action text-normal-overview pl-1" target="_blank" >
                                        <i className="far fa-file-download"></i> {document.description&&document.description[language]}</a></Col></Row>;
                            })
                        }
                        </CardBody>
                    </Collapse>
                    </Card>
                    : null
            }

        </React.Fragment>
    }
}

export const ImageCard = connect(null, null)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/ImageCard.tsx